import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import AdminNavbar from "../Layout/AdminNavbar";
import Papa from "papaparse";
import API_BASE_URL from "../config";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');

  .hm-root {
    font-family: 'DM Sans', sans-serif;
    background: #FFFFFF;
    min-height: 100vh;
    color: #1a1a1a;
  }

  .hm-page {
  padding: 120px 24px 40px;
  width: 100%;
  max-width: 100%;
  margin: 0;
}

  /* ── Header ── */
  .hm-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 28px;
  }
  .hm-title {
    font-size: 26px;
    font-weight: 600;
    letter-spacing: -0.5px;
    color: #111;
    margin: 0;
  }
  .hm-subtitle {
    font-size: 13px;
    color: #888;
    margin: 4px 0 0;
    font-weight: 400;
  }
  .hm-actions {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  /* ── Buttons ── */
  .btn-ghost {
    background: #fff;
    border: 1px solid #e2e2e2;
    color: #444;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 13px;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .btn-ghost:hover { background: #f0f0ee; border-color: #ccc; }

  .btn-primary-hm {
    background: #0052CC;
    border: 1px solid #f4fdff;
    color: #fff;
    padding: 8px 18px;
    border-radius: 8px;
    font-size: 13px;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .btn-primary-hm:hover { background: #0052CC; }

  .btn-upload {
    background: #fff;
    border: 1px dashed #bbb;
    color: #555;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 13px;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .btn-upload:hover { border-color: #999; background: #fafafa; }

  /* ── Toolbar Card ── */
  .hm-toolbar {
    background: #fff;
    border: 1px solid #e8e8e6;
    border-radius: 12px;
    padding: 18px 20px;
    margin-bottom: 16px;
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
  }
  .hm-search {
    flex: 1;
    min-width: 200px;
    position: relative;
  }
  .hm-search input {
    width: 100%;
    padding: 8px 12px 8px 36px;
    border: 1px solid #e2e2e2;
    border-radius: 8px;
    font-size: 13px;
    font-family: 'DM Sans', sans-serif;
    background: #fafaf9;
    color: #222;
    outline: none;
    transition: border 0.15s;
    box-sizing: border-box;
  }
  .hm-search input:focus { border-color: #999; background: #fff; }
  .hm-search-icon {
    position: absolute;
    left: 11px;
    top: 50%;
    transform: translateY(-50%);
    color: #aaa;
    font-size: 14px;
    pointer-events: none;
  }
  .hm-select {
    padding: 8px 12px;
    border: 1px solid #e2e2e2;
    border-radius: 8px;
    font-size: 13px;
    font-family: 'DM Sans', sans-serif;
    background: #fafaf9;
    color: #333;
    outline: none;
    cursor: pointer;
    transition: border 0.15s;
  }
  .hm-select:focus { border-color: #999; }

  /* ── Weekly Holidays ── */
  .hm-weekly {
    background: #fff;
    border: 1px solid #e8e8e6;
    border-radius: 12px;
    padding: 18px 20px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 24px;
    flex-wrap: wrap;
  }
  .hm-weekly-label {
    font-size: 13px;
    font-weight: 600;
    color: #555;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
  }
  .hm-weekly-days {
    display: flex;
    gap: 10px;
  }
  .hm-day-pill {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 14px;
    border-radius: 20px;
    border: 1px solid #e2e2e2;
    background: #fafaf9;
    cursor: pointer;
    transition: all 0.15s;
    font-size: 13px;
    font-weight: 500;
    color: #555;
    user-select: none;
  }
  .hm-day-pill:hover { border-color: #aaa; }
  .hm-day-pill.active {
    background: #0052CC;
    border-color: #FFFFFF;
    color: #fff;
  }
  .hm-day-pill input { display: none; }

  /* ── Table Card ── */
  .hm-table-card {
    background: #fff;
    border: 1px solid #e8e8e6;
    border-radius: 12px;
    overflow: hidden;
  }
  .hm-table-wrap {
    overflow-x: auto;
    max-height: 52vh;
    overflow-y: auto;
  }
  table.hm-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }
  table.hm-table thead th {
    background: #fafaf9;
    border-bottom: 1px solid #e8e8e6;
    padding: 11px 16px;
    text-align: left;
    font-weight: 600;
    color: #666;
    font-size: 11.5px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 1;
  }
  table.hm-table tbody tr {
    border-bottom: 1px solid #f0f0ee;
    transition: background 0.1s;
  }
  table.hm-table tbody tr:last-child { border-bottom: none; }
  table.hm-table tbody tr:hover { background: #fafaf9; }
  table.hm-table tbody td {
    padding: 11px 16px;
    color: #333;
    vertical-align: middle;
  }
  .hm-empty {
    padding: 56px;
    text-align: center;
    color: #aaa;
    font-size: 14px;
  }

  /* ── Type Badge ── */
  .type-badge {
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }
  .type-PUBLIC    { background: #f0f0ee; color: #555; }
  .type-NATIONAL  { background: #eaf0f8; color: #3a6090; }
  .type-RELIGIOUS { background: #f5f0e8; color: #7a5a2a; }
  .type-FESTIVAL  { background: #edf5ed; color: #356035; }
  .type-OPTIONAL  { background: #f5edf5; color: #603560; }

  /* ── Row Actions ── */
  .row-action {
    background: none;
    border: none;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 12px;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s;
  }
  .row-edit  { color: #3a6090; }
  .row-edit:hover  { background: #eaf0f8; }
  .row-del   { color: #c0392b; }
  .row-del:hover   { background: #fdf0ee; }

  /* ── Footer ── */
  .hm-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    border-top: 1px solid #f0f0ee;
    font-size: 12.5px;
    color: #888;
  }
  .hm-pagination { display: flex; gap: 4px; }
  .pg-btn {
    background: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 6px;
    padding: 5px 10px;
    font-size: 12px;
    font-family: 'DM Sans', sans-serif;
    cursor: pointer;
    color: #444;
    transition: all 0.12s;
  }
  .pg-btn:hover:not(:disabled) { background: #f5f5f3; border-color: #bbb; }
  .pg-btn.active { background: #0052CC; color: #fff; border-color: #FFFFFF; }
  .pg-btn:disabled { opacity: 0.4; cursor: default; }

  /* ── Loading ── */
  .hm-loading {
    padding: 64px;
    text-align: center;
    color: #aaa;
    font-size: 14px;
  }
  .hm-spinner {
    display: inline-block;
    width: 20px; height: 20px;
    border: 2px solid #e2e2e2;
    border-top-color: #555;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
    margin-right: 10px;
    vertical-align: middle;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  /* ── Modal ── */
  .hm-overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.35);
    backdrop-filter: blur(3px);
    z-index: 1050;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }
  .hm-modal {
    background: #fff;
    border-radius: 14px;
    width: 100%;
    max-width: 600px;
    box-shadow: 0 24px 60px rgba(0,0,0,0.15);
    overflow: hidden;
    animation: modalIn 0.2s ease;
  }
  @keyframes modalIn {
    from { opacity: 0; transform: translateY(12px) scale(0.98); }
    to   { opacity: 1; transform: none; }
  }
  .hm-modal-header {
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f0f0ee;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .hm-modal-title {
    font-size: 16px;
    font-weight: 600;
    color: #111;
    margin: 0;
  }
  .hm-modal-close {
    background: #f5f5f3;
    border: none;
    width: 28px; height: 28px;
    border-radius: 50%;
    font-size: 16px;
    cursor: pointer;
    color: #666;
    display: flex; align-items: center; justify-content: center;
    transition: background 0.15s;
  }
  .hm-modal-close:hover { background: #eaeae8; }
  .hm-modal-body { padding: 22px 24px; }
  .hm-modal-footer {
    padding: 14px 24px;
    border-top: 1px solid #f0f0ee;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  /* ── Form Fields ── */
  .hm-field { margin-bottom: 16px; }
  .hm-field label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 6px;
  }
  .hm-input {
    width: 100%;
    padding: 9px 12px;
    border: 1px solid #e2e2e2;
    border-radius: 8px;
    font-size: 13.5px;
    font-family: 'DM Sans', sans-serif;
    color: #222;
    background: #fafaf9;
    outline: none;
    transition: border 0.15s, box-shadow 0.15s;
    box-sizing: border-box;
  }
  .hm-input:focus {
    border-color: #888;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(0,0,0,0.05);
  }
  .hm-textarea {
    resize: vertical;
    min-height: 80px;
  }
  .hm-form-row { display: grid; gap: 14px; }
  .hm-form-row-2 { grid-template-columns: 1fr 1fr; }
  .hm-form-row-3 { grid-template-columns: 1fr 1fr 1fr; }

  .hm-check-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: #fafaf9;
    border: 1px solid #e2e2e2;
    border-radius: 8px;
    cursor: pointer;
    transition: border 0.15s;
    height: 40px;
    box-sizing: border-box;
    margin-top: 22px;
  }
  .hm-check-wrap:hover { border-color: #aaa; }
  .hm-check-wrap input[type="checkbox"] {
    width: 15px; height: 15px;
    accent-color: #0052CC;
    cursor: pointer;
    margin-right: 8px;
  }
  .hm-check-wrap span {
    font-size: 13.5px;
    font-weight: 500;
    color: #444;
  }

  /* ── Recurring dot ── */
  .rec-dot {
    display: inline-block;
    width: 7px; height: 7px;
    border-radius: 50%;
    background: #2ecc71;
    margin-right: 5px;
    vertical-align: middle;
  }
  .norec-dot {
    display: inline-block;
    width: 7px; height: 7px;
    border-radius: 50%;
    background: #e2e2e2;
    margin-right: 5px;
    vertical-align: middle;
  }

  /* Responsive */
  @media (max-width: 640px) {
    .hm-form-row-2, .hm-form-row-3 { grid-template-columns: 1fr; }
    .hm-header { flex-direction: column; gap: 14px; }
    .hm-toolbar { gap: 8px; }
  }
`;

export default function Holiday() {
    const [holidays, setHolidays] = useState([]);
    const [loading, setLoading] = useState(false);
    const [weeklyHolidays, setWeeklyHolidays] = useState([]);
    const navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);
    const [editing, setEditing] = useState(null);

    const emptyForm = { id: "", name: "", startDate: "", endDate: "", type: "PUBLIC", recurring: false, description: "" };
    const [form, setForm] = useState(emptyForm);

    const [query, setQuery] = useState("");
    const [filterYear, setFilterYear] = useState(new Date().getFullYear().toString());
    const [filterType, setFilterType] = useState("");
    const [page, setPage] = useState(1);
    const pageSize = 10;

    useEffect(() => { fetchWeeklyHolidays(); }, []);

    useEffect(() => {
        const token = localStorage.getItem("token");
        const roles = JSON.parse(localStorage.getItem("roles") || "[]");
        if (!token) { toast.error("You must be logged in."); navigate("/"); return; }
        if (!roles.includes("ROLE_ADMIN")) { toast.error("Not authorized."); navigate("/"); return; }
    }, [navigate]);

    async function fetchWeeklyHolidays() {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${API_BASE_URL}/api/holidays/weekly`, { headers: { Authorization: `Bearer ${token}` } });
            setWeeklyHolidays(res.data.map(h => h.name));
        } catch (err) { console.error(err); }
    }

    async function toggleWeeklyHoliday(day) {
        try {
            const updated = weeklyHolidays.includes(day)
                ? weeklyHolidays.filter(d => d !== day)
                : [...weeklyHolidays, day];
            setWeeklyHolidays(updated);
            const token = localStorage.getItem("token");
            await axios.post("/api/holidays/weekly", updated, { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } });
        } catch (err) { console.error(err); }
    }

    async function handleCSVUpload(e) {
        const file = e.target.files[0];
        if (!file) return;
        Papa.parse(file, {
            header: true, skipEmptyLines: true,
            complete: async (results) => {
                try {
                    const valid = results.data.filter(r => r.Name && r["Start Date"] && r["End Date"]);
                    if (!valid.length) { alert("No valid records found."); return; }
                    const token = localStorage.getItem("token");
                    const payload = valid.map(r => ({ name: r.Name.trim(), startDate: r["Start Date"].trim(), endDate: r["End Date"].trim(), type: r.Type?.trim() || "PUBLIC", recurring: r.Recurring?.toLowerCase() === "yes", description: r.Description || "" }));
                    for (const h of payload) await axios.post("/api/holidays", h, { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } });
                    toast.success(`${payload.length} holidays uploaded!`);
                    fetchHolidays();
                } catch (err) { console.error(err); alert("Upload failed."); }
            }
        });
    }

    useEffect(() => { fetchHolidays(); }, []);

    async function fetchHolidays() {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get("/api/holidays", { headers: { Authorization: `Bearer ${token}` } });
            setHolidays(Array.isArray(res.data) ? res.data : res.data.holidays || []);
        } catch (err) { console.error(err); } finally { setLoading(false); }
    }

    function openAdd() { setEditing(null); setForm(emptyForm); setShowModal(true); }
    function openEdit(h) {
        setEditing(h);
        setForm({ id: h.id || "", name: h.name || "", startDate: (h.startDate || "").slice(0, 10), endDate: (h.endDate || "").slice(0, 10), type: h.type || "PUBLIC", recurring: !!h.recurring, description: h.description || "" });
        setShowModal(true);
    }
    function closeModal() { setShowModal(false); setEditing(null); setForm(emptyForm); }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
    };

    async function handleSave(e) {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            const cfg = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
            if (editing) await axios.put(`/api/holidays/${editing.id}`, form, cfg);
            else await axios.post("/api/holidays", form, cfg);
            await fetchHolidays();
            closeModal();
            toast.success(editing ? "Holiday updated!" : "Holiday added!");
        } catch (err) { console.error(err); alert("Failed to save."); }
    }

    async function handleDelete(id) {
        if (!window.confirm("Delete this holiday?")) return;
        try {
            const token = localStorage.getItem("token");
            await axios.delete(`/api/holidays/${id}`, { headers: { Authorization: `Bearer ${token}` } });
            setHolidays(prev => prev.filter(p => p.id !== id));
            toast.success("Holiday deleted.");
        } catch (err) { console.error(err); alert("Failed to delete."); }
    }

    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        return holidays.filter(h => {
            if (q && !((h.name || "").toLowerCase().includes(q) || (h.description || "").toLowerCase().includes(q))) return false;
            if (filterYear && (h.startDate || "").slice(0, 4) !== filterYear) return false;
            if (filterType && (h.type || "").toUpperCase() !== filterType.toUpperCase()) return false;
            return true;
        }).sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
    }, [holidays, query, filterYear, filterType]);

    const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
    useEffect(() => { if (page > totalPages) setPage(1); }, [totalPages]);
    const pageItems = filtered.slice((page - 1) * pageSize, page * pageSize);

    function exportCSV() {
        const rows = ["Name,Start Date,End Date,Type,Recurring,Description"];
        filtered.forEach(h => rows.push([`"${(h.name || "").replace(/"/g, '""')}"`, h.startDate?.slice(0, 10) || "", h.endDate?.slice(0, 10) || "", h.type || "", h.recurring ? "Yes" : "No", `"${(h.description || "").replace(/"/g, '""')}"`].join(",")));
        const blob = new Blob([rows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a"); a.href = url; a.download = `holidays_${new Date().toISOString().slice(0, 10)}.csv`; a.click();
        URL.revokeObjectURL(url);
    }

    const years = useMemo(() => {
        const cur = new Date().getFullYear();
        const s = new Set();
        holidays.forEach(h => h.startDate && s.add(h.startDate.slice(0, 4)));
        for (let y = cur - 10; y <= cur + 2; y++) s.add(String(y));
        return Array.from(s).sort((a, b) => b - a);
    }, [holidays]);

    const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—";

    return (
        <>
            <style>{styles}</style>
            <div className="hm-root">
                <div className="fixed-top"><AdminNavbar /></div>

                <div className="hm-page">
                    {/* Header */}
                    <div className="hm-header">
                        <div>
                            <h1 className="hm-title">Holiday Master</h1>
                            <p className="hm-subtitle">Manage public, national and optional holidays</p>
                        </div>
                        <div className="hm-actions">
                            <button className="btn-ghost" onClick={fetchHolidays}>
                                ↻ Refresh
                            </button>
                            <label className="btn-upload">
                                ↑ Import CSV
                                <input type="file" accept=".csv" hidden onChange={handleCSVUpload} />
                            </label>
                            <button className="btn-primary-hm" onClick={openAdd}>
                                + Add Holiday
                            </button>
                        </div>
                    </div>

                    {/* Weekly Holidays */}
                    <div className="hm-weekly">
                        <span className="hm-weekly-label">Weekly Off</span>
                        <div className="hm-weekly-days">
                            {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(day => (
                                <label
                                    key={day}
                                    className={`hm-day-pill ${weeklyHolidays.includes(day) ? "active" : ""}`}
                                >
                                    <input
                                        type="checkbox"
                                        checked={weeklyHolidays.includes(day)}
                                        onChange={() => toggleWeeklyHoliday(day)}
                                    />
                                    {day}
                                </label>
                            ))}
                        </div>
                    </div>

                    {/* Toolbar */}
                    <div className="hm-toolbar">
                        <div className="hm-search">
                            <span className="hm-search-icon">⌕</span>
                            <input placeholder="Search by name or description…" value={query} onChange={e => { setQuery(e.target.value); setPage(1); }} />
                        </div>
                        <select className="hm-select" value={filterYear} onChange={e => { setFilterYear(e.target.value); setPage(1); }}>
                            <option value="">All Years</option>
                            {years.map(y => <option key={y} value={y}>{y}</option>)}
                        </select>
                        <select className="hm-select" value={filterType} onChange={e => { setFilterType(e.target.value); setPage(1); }}>
                            <option value="">All Types</option>
                            <option value="PUBLIC">Public</option>
                            <option value="NATIONAL">National</option>
                            <option value="RELIGIOUS">Religious</option>
                            <option value="FESTIVAL">Festival</option>
                            <option value="OPTIONAL">Optional</option>
                        </select>
                        <button className="btn-ghost" onClick={exportCSV} style={{ marginLeft: "auto" }}>
                            ↓ Export CSV
                        </button>
                    </div>

                    {/* Table */}
                    <div className="hm-table-card">
                        <div className="hm-table-wrap">
                            {loading ? (
                                <div className="hm-loading"><span className="hm-spinner" />Loading holidays…</div>
                            ) : (
                                <table className="hm-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: 44 }}>Sr no</th>
                                            <th style={{ width: 130 }}>Name</th>
                                            <th style={{ width: 220 }}>Date Range</th>
                                            <th style={{ width: 80 }}>Days</th>
                                            <th style={{ width: 110 }}>Type</th>
                                            <th style={{ width: 100 }}>Recurring</th>
                                            <th>Description</th>
                                            <th style={{ width: 150 }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pageItems.length === 0 ? (
                                            <tr><td colSpan={8}><div className="hm-empty">No holidays found for the selected filters.</div></td></tr>
                                        ) : pageItems.map((h, idx) => {
                                            const start = new Date(h.startDate);
                                            const end = h.endDate ? new Date(h.endDate) : start;
                                            const days = Math.floor((end - start) / 86400000) + 1;
                                            return (
                                                <tr key={h.id || idx}>
                                                    <td style={{ color: "#aaa", fontFamily: "'DM Mono', monospace", fontSize: 12 }}>{(page - 1) * pageSize + idx + 1}</td>
                                                    <td style={{ fontWeight: 500, color: "#111" }}>{h.name}</td>
                                                    <td style={{ fontFamily: "'DM Mono', monospace", fontSize: 12, color: "#555" }}>
                                                        {fmtDate(h.startDate)}{h.endDate ? <> <span style={{ color: "#bbb" }}>→</span> {fmtDate(h.endDate)}</> : ""}
                                                    </td>
                                                    <td style={{ fontFamily: "'DM Mono', monospace", fontSize: 12, color: "#666" }}>{days}d</td>
                                                    <td>
                                                        <span className={`type-badge type-${h.type}`}>{h.type}</span>
                                                    </td>
                                                    <td>
                                                        {h.recurring
                                                            ? <span><span className="rec-dot" />Yes</span>
                                                            : <span><span className="norec-dot" />No</span>}
                                                    </td>
                                                    <td style={{ color: "#777", fontSize: 12.5, maxWidth: 260 }}>{h.description || "—"}</td>
                                                    <td>
                                                        <button className="row-action row-edit" onClick={() => openEdit(h)}>Edit</button>
                                                        <button className="row-action row-del" onClick={() => handleDelete(h.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        <div className="hm-footer">
                            <span>{filtered.length} result{filtered.length !== 1 ? "s" : ""}</span>
                            <div className="hm-pagination">
                                <button className="pg-btn" disabled={page === 1} onClick={() => setPage(p => p - 1)}>‹ Prev</button>
                                {Array.from({ length: totalPages }).map((_, i) => (
                                    <button key={i} className={`pg-btn ${page === i + 1 ? "active" : ""}`} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                ))}
                                <button className="pg-btn" disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>Next ›</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal */}
                {showModal && (
                    <div className="hm-overlay" onClick={e => e.target === e.currentTarget && closeModal()}>
                        <div className="hm-modal">
                            <div className="hm-modal-header">
                                <h2 className="hm-modal-title">{editing ? "Edit Holiday" : "Add Holiday"}</h2>
                                <button className="hm-modal-close" onClick={closeModal}>×</button>
                            </div>
                            <form onSubmit={handleSave}>
                                <div className="hm-modal-body">
                                    <div className="hm-field">
                                        <label>Holiday Name</label>
                                        <input className="hm-input" name="name" value={form.name} onChange={handleChange} placeholder="e.g. Republic Day" required />
                                    </div>
                                    <div className="hm-form-row hm-form-row-3" style={{ marginBottom: 16 }}>
                                        <div className="hm-field" style={{ margin: 0 }}>
                                            <label>Start Date</label>
                                            <input className="hm-input" name="startDate" type="date" value={form.startDate} onChange={handleChange} required />
                                        </div>
                                        <div className="hm-field" style={{ margin: 0 }}>
                                            <label>End Date</label>
                                            <input className="hm-input" name="endDate" type="date" value={form.endDate} min={form.startDate} onChange={handleChange} required />
                                        </div>
                                        <div className="hm-field" style={{ margin: 0 }}>
                                            <label>Type</label>
                                            <select className="hm-input" name="type" value={form.type} onChange={handleChange}>
                                                <option value="PUBLIC">Public</option>
                                                <option value="NATIONAL">National</option>
                                                <option value="RELIGIOUS">Religious</option>
                                                <option value="FESTIVAL">Festival</option>
                                                <option value="OPTIONAL">Optional</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="hm-form-row hm-form-row-2" style={{ marginBottom: 16 }}>
                                        <div className="hm-field" style={{ margin: 0 }}>
                                            <label>Description</label>
                                            <textarea className="hm-input hm-textarea" name="description" value={form.description} onChange={handleChange} placeholder="Optional notes…" rows={3} />
                                        </div>
                                        <div className="hm-field" style={{ margin: 0 }}>
                                            <label style={{ visibility: "hidden" }}>_</label>
                                            <label className="hm-check-wrap">
                                                <input type="checkbox" name="recurring" checked={form.recurring} onChange={handleChange} />
                                                <span>Recurring annually</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="hm-modal-footer">
                                    <button type="submit" className="btn-primary-hm">Save</button>
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={closeModal}>Cancel</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}